import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { AppServiceManager } from 'common/services/appServiceManager';
import { Employee } from '../domain/employee';
import { IAddress } from "../domain/address";
import { IUser } from 'app/shared/Domains/IUser';
import { AuthService } from 'common/services/auth.service';
import { Configuration } from 'config/config';
import globalVariable from "../../../globalVariable/globalVariable.json";
import { ITrainer } from 'app/shared/Domains/trainer';
import { IPayDetails } from '../domain/payDetails';
import { ICompany } from 'app/shared/Domains/company';
import { AppUtils } from 'common/services/app.util';
import { IBranch } from 'app/shared/Domains/branch';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-add-employee',
  host: { "(window:keyup)": "hotkeys($event)", "(window:click)": "hotClick($event)" },
  templateUrl: './add-employee.component.html',
  styleUrls: ['./add-employee.component.css']
})
export class AddEmployeeComponent implements OnInit {
  @ViewChild("employeeName", { static: false }) employeeNameInput: ElementRef;
  employeeId: string;
  mode: string;
  tabIndex: number;
  Employee: Employee;
  addProfileImage: any;
  dialogVisibility: boolean;
  uploadProfile: any;
  selectedDesignation: any;
  sourceDesignation: any[];
  webcamImage: any = null;
  showProfileImage: any = null;
  loading: boolean = false;
  designations: any[];
  user: IUser;
  errorExempleNumber: any;
  currentStep: any;
  existUsers: IUser[] = [];
  selectedExistUserId: string;
  employeeAsUser: any;
  employeeAsTrainer: any;
  existingUsersDialog: boolean = false;
  existingTrainersDialog: boolean = false;
  firstOfUserTable: number = 0;
  firstOfTrainerTable: number = 0;
  users: any[];
  trainers: any[];
  sourceTrainers: any[];
  role: any;
  employees: any[];
  sourceEmployees: any[];
  sourceUsers: any[];
  userObject: IUser;
  trainer: ITrainer;
  enterSteps: any[];
  isConfirmationBox: boolean;
  months: { label: string; value: number }[];
  years: { label: string; value: number }[];
  issueSalaryDialogVisibility: boolean = false;
  pay: IPayDetails;
  date: Date;
  currentMonth: number;
  currentYear: number;
  TrainerShare: any;
  showCommentBox: boolean = false;
  salaryComment: string = "";
  salaryAlreadyPaid: boolean = false;
  isEnableIssueSalaryButtton: boolean = false;
  company: ICompany;
  branchSessionStorage: string;
  companySessionStorage: string;
  oldEmployeeImage: any;
  branch:IBranch;

  constructor(

    private LanguageService: LanguageService,
    private breadcrumbService: BreadcrumbService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private appServiceManager: AppServiceManager,
    private confirmationService: ConfirmationService,
    public config: Configuration,
    private router: Router,
  ) {
    route.params.subscribe((params) => {
      this.employeeId = params["id"];
      if (this.employeeId !== null && this.employeeId != undefined) {
        this.getEmployeeById();
        this.mode = "edit";
      } else {
        this.mode = "add";
        // this.filePath = "assets/layout/images/avatarBoyImage.png";
        this.employeeAsUser = JSON.parse(localStorage.getItem("EmployeeAsUserObject"));
        this.employeeAsTrainer = JSON.parse(localStorage.getItem("EmployeeAsTrainerObject"));
      }
      this.breadcrumbService.setItems([
        { label: "Employees", routerLink: ["/employees-listing"] },
        { label: "Employee" },
      ]);
    })
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("AddEmployeeComponent", label);
  }
  ngOnInit() {
    this.date = new Date();
    this.role = AuthService.getLoggedInRole();
    this.user = AuthService.getLoggedInUser();
    this.companySessionStorage = this.user.company;
    this.branchSessionStorage = this.user.branch;
    this.getCompany();
    this.getBranch();
    this.getExistingUsers();
    this.getExistingTrainers();
    this.getEmployees();
    this.errorExempleNumber = globalVariable.exampledata.pakNumber;
    this.Employee = new Employee();
    this.Employee.gender = 'Male';
    this.Employee.address = new IAddress();
    this.company = new ICompany();
    this.tabIndex = 0;
    this.dialogVisibility = false;
    this.addProfileImage = "Upload";
    this.showProfileImage = "";
    this.designations = [];
    this.getDesignations();
    this.currentStep = 0;
    this.Employee.createdDate = new Date();
    // this.Employee.profile = this.config.Server + "assets/layout/images/avatarBoyImage.png";
    this.Employee.address.country = "Pakistan";
    this.Employee.address.city = "Islamabad";
    this.users = [];
    this.sourceUsers = [];
    this.trainers = [];
    this.sourceTrainers = [];
    this.employees = [];
    this.sourceEmployees = [];
    this.userObject = new IUser();
    this.trainer = new ITrainer();
    this.isConfirmationBox = false;
    this.pay = new IPayDetails();
    this.currentMonth = (this.date.getMonth() + 1);
    this.currentYear = this.date.getUTCFullYear();

    if (this.employeeAsUser != undefined) {
      this.setEmployeeFieldsByUserData();
    }
    else if (this.employeeAsTrainer != undefined) {
      this.setEmployeeFieldsByTrainerData();
    }

    this.months = [
      { label: "Select Month", value: null },
      { label: "January", value: 1 },
      { label: "Febuary", value: 2 },
      { label: "March", value: 3 },
      { label: "April", value: 4 },
      { label: "May", value: 5 },
      { label: "June", value: 6 },
      { label: "July", value: 7 },
      { label: "August", value: 8 },
      { label: "September", value: 9 },
      { label: "October", value: 10 },
      { label: "November", value: 11 },
      { label: "December", value: 12 },
    ];

    this.years = [
      { label: "Select Year", value: null },
      { label: "2015", value: 2015 },
      { label: "2016", value: 2016 },
      { label: "2017", value: 2017 },
      { label: "2018", value: 2018 },
      { label: "2019", value: 2019 },
      { label: "2020", value: 2020 },
      { label: "2021", value: 2021 },
      { label: "2022", value: 2022 },
      { label: "2023", value: 2023 },
      { label: "2024", value: 2024 },
      { label: "2025", value: 2025 },
      { label: "2026", value: 2026 },
      { label: "2027", value: 2027 },
      { label: "2028", value: 2028 },
      { label: "2029", value: 2029 },
      { label: "2030", value: 2030 },
      { label: "2031", value: 2031 },
      { label: "2032", value: 2032 },
      { label: "2033", value: 2033 },
      { label: "2034", value: 2034 },
      { label: "2035", value: 2035 },
      { label: "2036", value: 2036 },
      { label: "2037", value: 2037 },
      { label: "2038", value: 2038 },
      { label: "2039", value: 2039 },
      { label: "2040", value: 2040 },
    ];

    if (this.mode == 'edit') {
      this.enterSteps = [
        "employeeName",
        "employeeNumber",
        "employeeMail",
        "designationDd",
        "employeeGender",
        "employeeStreet",
        "employeeCity",
        "employeeCountry",
        "employeeComment",
        "updateButton"
      ];
    } else if (this.mode == 'add') {
      this.enterSteps = [
        "employeeName",
        "employeeNumber",
        "employeeMail",
        "designationDd",
        "employeeGender",
        "employeeStreet",
        "employeeCity",
        "employeeCountry",
        "employeeComment",
        "saveButton"
      ];
    }
  }

  ngOnDestroy() {
    if (localStorage.getItem('EmployeeAsUserObject') !== null) {
      localStorage.removeItem("EmployeeAsUserObject");
    } else if (localStorage.getItem('EmployeeAsTrainerObject') !== null) {
      localStorage.removeItem("EmployeeAsTrainerObject");
    }
  }

  ngAfterViewInit() {
    this.employeeNameInput.nativeElement.focus();
  }

  getCompany() {
    this.appServiceManager.get("companies/" + this.user.company).subscribe(
      (res) => {
        if (res) {
          this.company = res;
        } else {
          this.company = new ICompany();
          this.messageService.clear();
          this.messageService.add({
            severity: "info",
            summary: "Info Message",
            detail: "Something Went Wrong",
          });
        }
      },
      (error) => {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({
          severity: "error",
          summary: "Error Message",
          detail: error,
        });
      }
    );
  }
  getBranch() {
    this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
        if (res) {
            this.branch = res;
        } else {
            this.branch = new IBranch();
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
    },
        (error) => {
            this.branch = new IBranch();
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
}


  setEmployeeFieldsByUserData() {
    this.Employee.name = this.employeeAsUser.name;
    this.Employee.phone = this.employeeAsUser.phone;
    this.Employee.email = this.employeeAsUser.email;
    this.Employee.userId = this.employeeAsUser._id;
    this.Employee.userCode = this.employeeAsUser.userCode;
    this.Employee.profile = this.employeeAsUser.profile;

  }

  setEmployeeFieldsByTrainerData() {
    this.Employee.name = this.employeeAsTrainer.name;
    this.Employee.phone = this.employeeAsTrainer.contact;
    this.Employee.email = this.employeeAsTrainer.email;
    this.Employee.trainerId = this.employeeAsTrainer._id;
    this.Employee.profile = this.employeeAsTrainer.profile;

  }

  getEmployeeById() {
    this.loading = true;
    this.appServiceManager.get("employees/getEmployee/" + this.employeeId).subscribe(
      data => {
        var date = new Date();
        this.Employee = data;
        this.Employee.createdDate = new Date(this.Employee.createdDate);
        this.loading = false;
        // this.pay.month = date.getMonth() + 1;
        // this.pay.year = date.getFullYear();

        if (this.Employee.trainerId != undefined) {
          this.getTrainerShare()
        } else {
          this.isEnableIssueSalaryButtton = true;
        }
      },
      error => {
        this.loading = false;
        alert(error);
      }
    );
  }

  onImgError(event) {
    event.target.src = 'assets/layout/images/avatarBoyImage.png'
  }

  getDesignations() {
    this.loading = true;
    this.appServiceManager.get(`hr/getAllDesignation/company/${this.user.company}/branch/${this.user.branch}`).subscribe((res: any) => {
      if (res.length > 0) {
        this.designations = res;
        this.sourceDesignation = this.createDdOptions(res, 'Select designation');
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  createDdOptions(ValueDetails: any[], name: string) {
    var itemsDd = [];
    var FirstOption = { label: name, value: 0 };
    itemsDd.push(FirstOption);
    ValueDetails.forEach(element => {
      var item = { label: element.name, value: element._id };
      itemsDd.push(item);
    });
    return itemsDd;
  }

  handleTabChange(e) {
    var index = e.index;
    if (index == 0) {
      this.tabIndex = 0;
    }
    if (index == 1) {
      this.tabIndex = 1;
    }
  }

  changeProfile() {
    setTimeout(() => {
      if (this.Employee.gender === "Female") {
        if (this.Employee.profile.includes('avatarBoyImage.png')) {
          this.Employee.profile =
            "assets/layout/images/avatarGirlImage.png";
        }
      }
      else if (this.Employee.gender === "Male") {
        if (this.Employee.profile.includes('avatarGirlImage.png')) {
          this.Employee.profile = "assets/layout/images/avatarBoyImage.png";
        }
      }
    }, 300);
  }

  save() {
    this.isConfirmationBox = true;
    this.confirmationService.confirm({
      message: "Are you sure you want to save Employee ?",
      accept: () => {
        this.isConfirmationBox = false;
        this.Employee.company = this.user.company;
        this.Employee.branch = this.user.branch;
        this.Employee.createdBy = this.user._id;
        this.appServiceManager.post("employees/createEmployee", this.Employee).subscribe((res: any) => {
          if (res) {
            this.Employee = res.employee;
            if (this.uploadProfile && this.Employee.profile) {
              const file = AppUtils.base64ToFile(this.uploadProfile, `${this.Employee.name}.png` + ":" + this.companySessionStorage + ":" + this.branchSessionStorage);
              this.uploadCustomerImage(file, this.Employee._id);
          }
            if (localStorage.getItem('EmployeeAsUserObject') !== null) {
              localStorage.removeItem("EmployeeAsUserObject");
            } else if (localStorage.getItem('EmployeeAsTrainerObject') !== null) {
              localStorage.removeItem("EmployeeAsTrainerObject");
            }
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Employee Successfully Created' });
            console.log(this.showProfileImage);
            setTimeout(() => {
              this.router.navigateByUrl('employee/' + this.Employee._id);
            }, 2000);
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });

      },
      reject: () => {
        this.isConfirmationBox = false;
      }
    });

  }

  update() {
    this.isConfirmationBox = true;
    this.confirmationService.confirm({
      message: "Are you sure you want to update Employee ?",
      accept: () => {
        this.isConfirmationBox = false;
        this.Employee.company = this.user.company;
        this.Employee.branch = this.user.branch;
        this.Employee.modifiedBy = this.user._id;
        this.appServiceManager.put("employees/updateEmployee/" + this.Employee._id, this.Employee).subscribe((res: any) => {
          if (res) {
            this.Employee.createdDate = new Date(this.Employee.createdDate);
            this.messageService.clear();
            if (this.uploadProfile && this.Employee.profile) {
              const file = AppUtils.base64ToFile(this.uploadProfile, `${this.Employee.name}.png` + ":" + this.companySessionStorage + ":" + this.branchSessionStorage);
              this.uploadCustomerImage(file, this.Employee._id, true);
            }
            else if (this.oldEmployeeImage && !this.Employee.profile) {
              this.showProfileImage = "";
              this.appServiceManager.delete(`employees/profileimages/${this.Employee._id}`).subscribe((res: any) => {
                if (res.message == "Profile image deleted successfully") {
                  this.messageService.clear();
                  this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Profile Image Deleted Please Reload' });
                }
              });
            }
          // this.Employee = res.employee;
          this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Employee Successfully Updated' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      },
      reject: () => {
        this.isConfirmationBox = false;
      }
    });
  }

  uploadCustomerImage(file: any, employeeId: string | Blob, isAddMode = false) {
    let formData: FormData = new FormData();
    if (file) {


        formData.append("employeeImage", file, file.name);
        formData.append("isThumb", "true");
        formData.append("employeeId", employeeId);
        formData.append("company", this.companySessionStorage);
        formData.append("branch", this.branchSessionStorage);
        formData.append("isAddMode", isAddMode.toString());

        this.appServiceManager.post("employees/upload", formData)
            .subscribe(
                async (res: any) => {
                },
                (error: any) => {
                    this.messageService.clear();
                    this.messageService.add({ severity: "error", summary: "Error Message", detail: error, });
                }
            );
    }
}

  captureImageDialogShow(type) {
    this.addProfileImage = type;
    this.dialogVisibility = true;
  }

  removeProfileImage() {
    this.oldEmployeeImage=this.Employee.profile;
    this.uploadProfile = "";
    this.showProfileImage = "";
    this.Employee.profile = "";
  }

  hideAddProfileImage() {
    this.dialogVisibility = false;
  }

  handleImagefromNewProfile(webcamImage) {
    if (webcamImage) {
      this.uploadProfile = webcamImage;
      this.Employee.profile = webcamImage;
      this.showProfileImage = webcamImage;
      this.webcamImage = null;
      this.hideAddProfileImage();
    }
  }

  viewEmployeeUser() {
    this.router.navigateByUrl('settings/user/' + this.Employee.userId);
  }

  viewEmployeeTrainer() {
    this.router.navigateByUrl('trainers/trainer/' + this.Employee.trainerId);
  }

  getExistingUsers() {
    this.loading = true;
    this.appServiceManager
    .get("users/company/" + this.user.company + "/branch/" + this.user.branch).subscribe(
        (res: any) => {
          if (res.length > 0) {
            res = this.role.name === 'Super Admin' ? res : res.filter((value: { userRole: any; }) => value.userRole.name !== "Super Admin");
            this.users = res;
            this.sourceUsers = res;
          } else {
            this.messageService.clear();
            this.messageService.add({
              severity: "info",
              summary: "Info Message",
              detail: "No Record Found",
            });
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: error.error.message,
          });
        }
      );
  }

  searchLocalUsers(value, type) {
    let matchedName = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.users = Object.assign([], this.sourceUsers);
      }
      if (!value) {
        this.users = Object.assign([], this.sourceUsers);
      }
      if (value != "") {
        if (type === "name") {
          matchedName = Object.assign([], this.sourceUsers).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName;
        this.users = source.filter(distinct);

        if (this.users.length === 0) {
          this.users = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.firstOfUserTable = 0;
          if (this.users.length === 1) {
            this.firstOfUserTable = 0;
          }
          this.users = [...this.users];
        }
      }
    } else {
      this.users = Object.assign([], this.sourceUsers);
      this.users = [...this.users];
    }
  }

  clearUserSearchField() {
    this.userObject = new IUser();
    this.searchLocalUsers("", "");
    this.firstOfUserTable = 0;
  }

  onPageChangeUsersTable(event) {
    this.firstOfUserTable = event.first;
  }

  getExistingTrainers() {
    this.loading = true;
    this.appServiceManager
      .get(
        "Trainers/company/" + this.user.company + "/branch/" + this.user.branch
      )
      .subscribe(
        (res: any) => {
          if (res.length > 0) {
            this.trainers = res;
            this.sourceTrainers = res;
          } else {
            this.messageService.clear();
            this.messageService.add({
              severity: "info",
              summary: "Info Message",
              detail: "No Record Found",
            });
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: error.error.message,
          });
        }
      );
  }

  searchLocalTrainers(value, type) {
    let matchedName = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.trainers = Object.assign([], this.sourceTrainers);
      }
      if (!value) {
        this.trainers = Object.assign([], this.sourceTrainers);
      }
      if (value != "") {
        if (type === "name") {
          matchedName = Object.assign([], this.sourceTrainers).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName;
        this.trainers = source.filter(distinct);

        if (this.trainers.length === 0) {
          this.trainers = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.firstOfTrainerTable = 0;
          if (this.trainers.length === 1) {
            this.firstOfTrainerTable = 0;
          }
          this.trainers = [...this.trainers];
        }
      }
    } else {
      this.trainers = Object.assign([], this.sourceTrainers);
      this.trainers = [...this.trainers];
    }
  }

  clearTrainersSearchField() {
    this.trainer = new ITrainer();
    this.searchLocalTrainers("", "");
    this.firstOfTrainerTable = 0;
  }

  onPageChangeTrainersTable(event) {
    this.firstOfTrainerTable = event.first;
  }

  linkTrainerWithEmployee(trainer) {
    let checkIfTrainerExistAsEmployee = this.employees.filter(x => x.trainerId == trainer._id);
    if (checkIfTrainerExistAsEmployee.length > 0) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'Trainer already added as employee' });
    } else {
      this.confirmationService.confirm({
        message: "Are you sure you want to link ?",
        accept: () => {
          this.Employee.trainerId = trainer._id;
          this.Employee.modifiedBy = this.user._id;
          this.appServiceManager.put("employees/connectTrainerWithEmployee/" + this.Employee._id, this.Employee).subscribe((res: any) => {
            if (res) {
              this.Employee = res.employee;
              this.existingTrainersDialog = false;
              this.messageService.clear();
              this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Employee linked Successfully' });
              this.router.navigateByUrl('employee/' + this.Employee._id)
            } else {
              this.messageService.clear();
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
            }
          },
            (error) => {
              this.messageService.clear();
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });

        },
        reject: () => {
        }
      });
    }

  }

  linkUserWithEmployee(user) {
    let checkIfUserExistAsEmployee = this.employees.filter(x => x.userId == user._id);
    if (checkIfUserExistAsEmployee.length > 0) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'User already added as employee' });
    } else {
      this.confirmationService.confirm({
        message: "Are you sure you want to link ?",
        accept: () => {
          this.Employee.userId = user._id;
          this.Employee.modifiedBy = this.user._id;
          this.appServiceManager.put("employees/connectUserWithEmployee/" + this.Employee._id, this.Employee).subscribe((res: any) => {
            if (res) {
              this.Employee = res.employee;
              this.existingUsersDialog = false;

              this.messageService.clear();
              this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Employee linked Successfully' });
              this.router.navigateByUrl('employee/' + this.Employee._id)
            } else {
              this.messageService.clear();
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
            }
          },
            (error) => {
              this.messageService.clear();
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });

        },
        reject: () => {
        }
      });
    }

  }

  getEmployees() {
    this.loading = true;
    this.appServiceManager.get(`employees/company/${this.user.company}/branch/${this.user.branch}/getAllEmployees`).subscribe((res: any) => {
      if (res.length > 0) {
        this.employees = res;
        this.sourceEmployees = res;
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  focusUserSearchInput() {
    this.clearUserSearchField();
    setTimeout(() => {
      document.getElementById("userSearch").focus();
    }, 300);
  }

  focusTrainerSearchInput() {
    this.clearTrainersSearchField();
    setTimeout(() => {
      document.getElementById("trainerSearch").focus();
    }, 300);
  }

  hotkeys($event) {
    if ($event.keyCode == 39 || $event.keyCode == 37) {
      var confirmationBox = document.getElementsByTagName("p-confirmdialog")[0];
      var confirmationBoxButtonExist = confirmationBox.getElementsByTagName("button");
      var confirmationBoxButtonExistLength = confirmationBox.getElementsByTagName("button").length;

      if (confirmationBoxButtonExistLength > 0) {
        if (document.activeElement.tagName === "BODY") {
          confirmationBoxButtonExist[0].focus();
        }
        else {
          if (document.activeElement === confirmationBoxButtonExist[0]) {
            confirmationBoxButtonExist[1].focus();
          }
          else if (document.activeElement === confirmationBoxButtonExist[1]) {
            confirmationBoxButtonExist[0].focus();
          }
          else {
            confirmationBoxButtonExist[0].focus();
          }
        }
      }
    }

    else if ($event.keyCode == 13 && !this.isConfirmationBox && !$event.shiftKey) {
      var nextStep = this.enterSteps.length - 1 > this.currentStep ? this.currentStep + 1 : 0;
      var nextId = this.enterSteps[nextStep];
      let ele: any = document.getElementById(nextId);

      if (ele == null && nextId == "employeeComment" && this.mode == "edit") {
        document.getElementById("updateButton").focus();
        this.currentStep = 0 - 1;

      }
      else if (nextId == "employeeGender") {
        let radioClassFocus: any = document.getElementsByClassName("ui-state-active")[1] as HTMLElement;
        radioClassFocus.click();
        this.currentStep = 4;

      } else if (ele.disabled && nextId == "saveButton") {
        $event.preventDefault();
        document.getElementById("employeeName").focus();
        this.currentStep = 0;

      } else if (ele.disabled && nextId == "updateButton") {
        $event.preventDefault();
        document.getElementById("employeeName").focus();
        this.currentStep = 0;

      } else if (nextId == "designationDd") {
        let ele = document.getElementById("designationDd").children[0] as HTMLElement;
        ele.click();
        this.currentStep = 3;

      } else {
        ele.focus();
        this.currentStep = nextStep;

      }
    } else if ($event.keyCode == 113) {
      this.router.navigateByUrl("/employee");

    }

  }

  hotClick($event) {
    let currentClickLocation = $event.target.id;
    let indexOfClickField = this.enterSteps.indexOf(currentClickLocation);
    if (indexOfClickField !== -1) {
      this.currentStep = indexOfClickField;
    } else {
      this.currentStep = this.currentStep;
    }
  }

  getMonth(monthNumber) {
    const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    let name = month[monthNumber - 1];
    return name;
  }

  deleteSalaryRecord(record) {
    this.confirmationService.confirm({
      message: "Are you sure you want to Delete ?",
      accept: () => {
        this.loading = true;
        this.appServiceManager.delete(`employees/deleteEmployeeSalary/${this.Employee._id}/invoiceNumber/${record._id}`).subscribe((res: any) => {

          if (res.status === true) {
            const index: number = this.Employee.payDetails.indexOf(record);

            if (index !== -1) {
              this.Employee.payDetails.splice(index, 1);
            }

            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Deleted' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
          this.loading = false;
          this.employees = [...this.employees]
        },
          (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      }
    });
  }

  getTrainerShare() {
    let body = {
      date: new Date(this.date)
    }
    this.appServiceManager.put(`hr/company/${this.user.company}/branch/${this.user.branch}/getTrainersFee/${this.Employee.trainerId}`, body).subscribe((res: any) => {
      if (res != undefined) {
        this.TrainerShare = res;
        this.isEnableIssueSalaryButtton = true;
      } else {
        this.TrainerShare = {};
        this.isEnableIssueSalaryButtton = true;

      }

    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  onChangeMonthDropDown() {
    this.date.setMonth(this.currentMonth - 1);
    this.salaryAlreadyPaid = false;
    if (this.Employee.trainerId != undefined) {
      this.getTrainerShare();
    }

    setTimeout(() => {
      this.setSalary();
    }, 1000);
  }

  onChangeYearDropDown() {
    this.date.setFullYear(this.currentYear);
    this.salaryAlreadyPaid = false;
    if (this.Employee.trainerId != undefined) {
      this.getTrainerShare();
    }

    setTimeout(() => {
      this.setSalary();
    }, 1000);
  }

  showIssueSalaryDialogue() {
    this.issueSalaryDialogVisibility = true;
    this.date = new Date();
    this.currentMonth = (this.date.getMonth() + 1);
    this.currentYear = this.date.getUTCFullYear();
    this.pay.description = undefined;
    this.onChangeMonthDropDown();
    this.onChangeYearDropDown();
    this.setSalary();
  }

  setSalary() {
    let employeeDesignationObject = this.designations.find(x => x._id == this.Employee.designation);
    this.pay.salary = employeeDesignationObject.salary;

    if (this.Employee.trainerId != undefined) {
      this.pay.trainerShare = this.TrainerShare.feeDetails.length * this.TrainerShare.trainerShare;
      this.pay.totalPaid = this.pay.salary + this.pay.trainerShare;

    } else {
      this.pay.totalPaid = this.pay.salary;

    }

  }

  updateEmployeeSalary() {
    let check = this.Employee.payDetails.filter(x => x.month == this.currentMonth && x.year == this.currentYear);
    if (check.length > 0) {
      this.salaryAlreadyPaid = true;
    } else {
      this.salaryAlreadyPaid = false;
      this.confirmationService.confirm({
        message: "Are you sure you want to issue Employee Salary ?",
        accept: () => {
          this.pay.invoice = Math.round(Math.random() * 1000).toString();
          this.pay.date = this.date;
          this.pay["status"] = "salary Issued";
          this.pay.month = this.currentMonth;
          this.pay.year = this.currentYear;
          let data = {};
          data["salary"] = this.pay;

          this.appServiceManager.put('employees/updateEmployeeSalary/' + this.Employee._id, data).subscribe((res: any) => {
            if (res.status) {
              this.Employee = res.employee;
              this.pay = this.pay;
              this.pay.date = new Date();
              this.issueSalaryDialogVisibility = false;
              setTimeout(() => {
                this.printSalaryInvoice();
              }, 300);
              this.messageService.clear();
              this.messageService.add({
                severity: "success",
                summary: "Success Message",
                detail: "Employee Salary Successfully Issued",
              });
            } else {
              this.messageService.clear();
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Something went wrong' });
            }
          },
            (error) => {
              this.loading = false;
              this.messageService.clear();
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
        },
        reject: () => { }
      });
    }

  }

  ShowCommentBox(pay) {
    if (pay.description != undefined) {
      this.showCommentBox = true;
      this.salaryComment = pay.description;
    } else {
      return;
    }
  }

  onSalaryFieldChange() {
    this.pay.totalPaid = this.pay.salary + this.pay.trainerShare;
  }

  printSalaryInvoice(): void {
    let printContents, popupWin;
    printContents = document.getElementById("salaryInvoice").innerHTML;
    popupWin = window.open(
      "",
      "_blank",
      "top=0,left=0,height=100%,width=auto"
    );
    popupWin.document.open();
    popupWin.document.write(`
      <html>
      <head>
        <title>Gym Employee Salary Invoice</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }

            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
      </head>
      <body>${printContents}</body>
      </html>
    `);
  }

}
